import { render, staticRenderFns } from "./readdialog.vue?vue&type=template&id=6b6ef0fe&scoped=true"
import script from "./readdialog.vue?vue&type=script&lang=js"
export * from "./readdialog.vue?vue&type=script&lang=js"
import style0 from "./readdialog.vue?vue&type=style&index=0&id=6b6ef0fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6ef0fe",
  null
  
)

export default component.exports